import React from 'react';
import ReactPlaceholder from 'react-placeholder';
import { connect } from 'react-redux';
import { listSensorOrder, sortSensors } from 'commons/src/commonFunctions';
import { deviceTypes } from 'commons/src/constants';
import Error from '../../components/error';
import PageHeader from '../../components/pageHeader/PageHeader';
import { publicDashboardPlaceholder } from '../../components/placeholder';
import PublicSensorTile from '../../components/tile/PublicSensorTile';
import { CurrentSensorValuesType } from '../../models/commons';
import { Store } from '../../reducers';

interface StateProps {
    deviceType: keyof typeof deviceTypes;
    deviceDataLoading: boolean;
    deviceDataError: boolean;
    sensorDataLoading: boolean;
    sensorDataError: boolean;
    sensorData: Array<CurrentSensorValuesType>;
}

export type Props = StateProps;

export const PublicDeviceViewComponent = ({
    deviceType,
    deviceDataLoading,
    deviceDataError,
    sensorDataLoading,
    sensorDataError,
    sensorData,
}: Props) => {
    const isLoading = deviceDataLoading || sensorDataLoading;
    const error = deviceDataError || sensorDataError;
    if (error) {
        return (
            <Error
                errorHeader="PublicIAQDashboard.DeviceNotPublic"
                errorText="ErrorCodes.PUBLIC_DEVICE_NOT_FOUND"
                errorIcon="visibility_off"
            />
        );
    }

    const order = listSensorOrder[deviceType];
    const tileBody = sortSensors(sensorData, order).map((sensor, index) => (
        <PublicSensorTile sensorType={sensor.type} sensorValue={sensor.value} key={index} />
    ));

    return (
        <ReactPlaceholder ready={!isLoading} customPlaceholder={publicDashboardPlaceholder}>
            <div>
                <PageHeader />
                <div className="public-page-wrapper">{tileBody}</div>
            </div>
        </ReactPlaceholder>
    );
};

const mapStateToProps = (state: Store): StateProps => {
    const {
        publicDeviceData: { loading: deviceDataLoading, error: deviceDataError, deviceType },
        publicDeviceSensorData: { loading: sensorDataLoading, error: sensorDataError, sensorData },
    } = state;
    return {
        deviceDataLoading,
        deviceDataError,
        deviceType,
        sensorDataLoading,
        sensorDataError,
        sensorData,
    };
};

export default connect(mapStateToProps)(PublicDeviceViewComponent);
